import axios from "axios";

const assasVerifyPayment = async ({ paymentId }) => {
  try {
    const { data } = await axios.post(
      `/asaas/verify/payment`,
      {
        paymentId: paymentId,
      }
    );

    if (!data?.success) throw new Error();

    return {
      success: true,
      message: "Sucesso ao verificar informações do pagamento",
      status: data?.status,
    };
  } catch (error) {
    return {
      success: false,
      message: "Erro ao verificar informações do pagamento",
    };
  }
};

export { assasVerifyPayment };
